import '../../App.css';
import React from 'react'
import "bootstrap/dist/css/bootstrap.css";
import { TableRow, TableCell, Link } from '@aws-amplify/ui-react';
import { Download } from 'react-bootstrap-icons';
import { downloadfile } from '../../utils/utils';

const EntityRow = (props) => {
    return (
        <React.Fragment>
            <TableRow>
                <TableCell>
                    <Link className='App-link' onClick={() => props.OnDetail(props.entity)}> {props.entity.file_name}</Link>
                </TableCell>
                <TableCell>
                    <Link className='App-link text-center' onClick={() => alert('Sign up for a free account to download uploaded files!')}><Download /></Link>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell colSpan={2} dangerouslySetInnerHTML={{ __html: props.entity.snippet }}>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )
}
export default EntityRow;